'use strict';

angular.module('PinMeTo.services').factory('auth', [
	'$http',
	'$q',
	'pmtEnvService',
	function ($http, $q, pmtEnvService) {
		const isDemo = localStorage.getItem('isDemo') === 'true' || false;
		let user = {};
		let permissions = {};

		const emptyLocalAccess = () => {
			return {
				roles: new Set(),
				groups: [],
				permissions: new Set(),
				locations: new Map()
			};
		};

		const emptyUser = () => {
			Object.getOwnPropertyNames(user).forEach(p => delete user[p]);
			user.isDemo = false;
			user._id = '';
			user.name = '';
			user.firstName = '';
			user.lastName = '';
			user.email = '';
			user.otpEnabled = 'NOT_ENABLED';
			user.mobilePhone = {
				countryCode: '',
				number: ''
			};
			user.isAdmin = false;
			user.selectedSite = null;

			user.settings = {};
			user.sites = [];
			user.systemRoles = [];
			user.localAccess = emptyLocalAccess();
		};

		const setUser = newUser => {
			Object.getOwnPropertyNames(user).forEach(p => delete user[p]);
			Object.getOwnPropertyNames(newUser).forEach(p => (user[p] = newUser[p]));
			user.isDemo = isDemo;
			user.isAdmin = user.isAdmin && !isDemo;

			// pmtPlantrack comes from pmt-ui.
			// it's esential to send survey from planhat to user.
			window.pmtPlantrack?.init({
				firstName: newUser.firstName,
				lastName: newUser.lastName,
				email: newUser.email,
				siteName: newUser.selectedSite.name
			});
		};

		const setPermissionOnUser = data => {
			user.localAccess = emptyLocalAccess();
			data.roles.forEach(x => user.localAccess.roles.add(x));
			user.localAccess.groups = data.groups;
			data.permissions.forEach(x => user.localAccess.permissions.add(x));
			data.locations.forEach(l => user.localAccess.locations.set(l.id, l));
		};

		const getPermissions = siteName => {
			let realm = pmtEnvService.isSocialApp ? 'locationpost' : 'places';
			if (!permissions[siteName]) {
				return (permissions[siteName] = $http
					.get('/api/' + siteName + '/user/permissions/' + realm)
					.then(response => {
						setPermissionOnUser(response.data);
						user.permissions = response.data;
						return user;
					}));
			} else {
				return permissions[siteName];
			}
		};

		let getUserPromise = {};
		const getUser = siteName => {
			if (siteName == null || siteName === '') {
				throw new Error('siteName is required');
			}
			if (user._id && user.selectedSite && siteName === user.selectedSite.name) {
				getUserPromise[siteName] = null;
				return $q.resolve(user);
			}
			if (getUserPromise[siteName] != null) {
				return getUserPromise[siteName];
			}
			const url = siteName == null ? 'api/user' : `api/user/${siteName}`;
			getUserPromise[siteName] = $http
				.get(url)
				.then((response, err) => {
					const code = response.status;
					if (err) {
						console.error('error getting user', code);
						return $q.reject(err);
					}
					if (code >= 300) {
						return $q.reject(code);
					}
					setUser(response.data);
				})
				.then(() => {
					permissions = {};
					return getPermissions(siteName);
				})
				.then(() => user)
				.catch(err => {
					emptyUser();
					return $q.reject(err);
				});

			return getUserPromise[siteName];
		};

		const reloadUser = siteName => {
			return getUser(siteName);
		};

		const getUserRoles = () => {
			return [...user.localAccess.roles];
		};

		const forceReloadUser = siteName => {
			getUserPromise[siteName] = null;
			permissions[siteName] = null;
			emptyUser();
			return getUser(siteName);
		};

		emptyUser();

		const userForPinMeToPage = () => {
			const localAccess = { ...user.localAccess };
			localAccess.roles = localAccess.roles ? [...localAccess.roles.values()] : [];
			localAccess.permissions = localAccess.permissions
				? [...localAccess.permissions.values()]
				: [];
			return {
				...user,
				localAccess: localAccess
			};
		};

		return {
			user: user,
			getUser: getUser,
			reloadUser: reloadUser,
			getUserRoles: getUserRoles,
			logout: emptyUser,
			forceReloadUser: forceReloadUser,
			userForPinMeToPage: userForPinMeToPage
		};
	}
]);
